const BR_DATE = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export interface MonthDay {
    month: number;
    day: number;
}

export function parseBirthDate(value: unknown): MonthDay | null {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();

    const br = BR_DATE.exec(trimmed);
    if (br) return validMonthDay(Number(br[2]), Number(br[1]));

    const iso = ISO_DATE.exec(trimmed);
    if (iso) return validMonthDay(Number(iso[2]), Number(iso[3]));

    return null;
}

function validMonthDay(month: number, day: number): MonthDay | null {
    if (month < 1 || month > 12 || day < 1 || day > 31) return null;
    return { month, day };
}

function isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

export function birthdayIsoInYear(monthDay: MonthDay, year: number): string {
    const month = String(monthDay.month).padStart(2, '0');
    const feb29 = monthDay.month === 2 && monthDay.day === 29 && !isLeapYear(year);
    const day = String(feb29 ? 28 : monthDay.day).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function nextBirthdayIso(birthDate: unknown, todayIso: string): string | null {
    const monthDay = parseBirthDate(birthDate);
    if (!monthDay) return null;

    const year = Number(todayIso.slice(0, 4));
    const thisYear = birthdayIsoInYear(monthDay, year);
    return thisYear >= todayIso ? thisYear : birthdayIsoInYear(monthDay, year + 1);
}
